module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAASCAYAAABrXO8xAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEASURBVHgBjVJRFYMwDGz39j8kVAISkDAJOIApGFMwHIAD5oBJQQIoYJc15YUSNvLeUZLetUkaa4TN85xgKYAUGDk8ARfgYa0dTGwQFUALOGXPATVQaqLK/DHiLGI+rdm5JVXidLOzLFrlT5tYFh97tTwQSx5I8sQrkAs/o1jE6U7Gd0yak7cZ310XcaaT2doLKLhGep6SY6tLz/gkREAdI9czwL+xgKxS3m+i5mSUCjZbc8C4/jE4Dad1RNhLhzr3PCC6h8n6NgdpvmnhtPdEqafq89ppKXOHe/PjVCJ0SrzRhj8mrerlurKYZ3fE9IZhoiY5q8G0yQlDbf3vVkT2AWd5zTnu35oSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/ubicacion.png
// module id = 880
// module chunks = 0